<template>
  <span
    :class="paletteItemClasses"
    :data-cy="DS_PALETTE_ITEM_DATA_CY"
    aria-hidden="true"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { DS_PALETTE_ITEM_CLASSES } from "@/src/design_system/data_display/palette_item/constants";
import { DS_PALETTE_ITEM_SIZES } from "@/src/design_system/data_display/palette_item/types";
import { DSPaletteItemProps } from "@/src/design_system/data_display/palette_item/types/props";
import { getPaletteClass } from "@/src/design_system/shared_modules/palette/utils/palette";

const DS_PALETTE_ITEM_DATA_CY = "ds-palette-item";

const props = withDefaults(defineProps<DSPaletteItemProps>(), {
  colorPalette: undefined,
  size: DS_PALETTE_ITEM_SIZES.Medium,
});

const paletteItemClasses = computed(() => {
  return [
    DS_PALETTE_ITEM_CLASSES.Base,
    `${DS_PALETTE_ITEM_CLASSES.Base}--${props.size}`,
    getPaletteClass(props.colorPalette),
  ];
});
</script>
